/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated with ApiClientGenerator, using the NSwag toolchain
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosRequestConfig, AxiosPromise, CancelToken } from 'axios';
import { injectable, inject, optional, symbolToken } from '@servicetitan/react-ioc';
import { makeCodedException, makeContent } from 'utils';
// @ts-ignore: needed for Date serialization if a DateTime parameter has an Unspecified attribute on it
import moment from 'moment';

export interface IFeBundleApi {
    getPackageUrl(isPilot: boolean | null, cancelToken?: CancelToken): AxiosPromise<string>;
}

export const BASE_URL_TOKEN_FeBundleApi = symbolToken<string>('BASE_URL_TOKEN', false);

@injectable()
export class FeBundleApi implements IFeBundleApi {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@inject(BASE_URL_TOKEN_FeBundleApi) @optional() private readonly baseUrl = "") {
    }

    getPackageUrl(isPilot: boolean | null, cancelToken?: CancelToken): AxiosPromise<string> {
        let url_ = "/fe-bundle/package-url?";
        if (isPilot === undefined)
            throw new Error("The parameter 'isPilot' must be defined.");
        else if (isPilot !== null)
            url_ += "isPilot=" + encodeURIComponent("" + isPilot) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<string>(options_));
    }
}
